import { LinkWithSlug } from "routes";

import { Button } from "@/components/elements/Button";
import Tooltip from "@/components/elements/Tooltip";
import { ModelIcon } from "@/pages/ModelTool/components/ModelIcon/ModelIcon";
import { truncateStringMiddle } from "@/shared/formatters/truncation";

import { RowData } from "../columns";

export const ModelCell = ({
  model,
  modelPath,
}: Pick<RowData, "model" | "modelPath">) => {
  if (!model) return <div />;
  const truncatedModelPath = truncateStringMiddle(modelPath ?? "", 30);
  return (
    <div className="-mx-2 whitespace-nowrap">
      <Tooltip content={modelPath ?? null}>
        <Button
          variant="ghost"
          icon={<ModelIcon model={model} />}
          size="sm"
          className="h-7 min-w-0 max-w-52 truncate px-1.5 text-xs font-normal leading-none hover:border-gray-300 dark:hover:border-gray-600 sm:text-sm"
          as={LinkWithSlug}
          to={`/editor/${model.id}`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <span className="truncate">{truncatedModelPath}</span>
        </Button>
      </Tooltip>
    </div>
  );
};
